<template>
  <div>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col cols="12">
            <left-emp-menu></left-emp-menu>
          </v-col>
          <v-col>
            <v-row>
              <v-col cols="12">
                <v-card>
                  <v-list three-line subheader>
                    <v-card-title class="lighten-5">
                      ข้อมูลส่วนตัว
                      <v-icon color="#871B12"
                        >mdi-account-circle-outline
                      </v-icon>
                    </v-card-title>
                    <v-divider color="#871B12"></v-divider>
                    <v-col cols="12" class="text-center">
                      <v-container grid-list-xl>
                        <v-avatar size="150px" class="grey lighten-3 mb-3">
                          <img :src="dataImg" />
                        </v-avatar>
                        <br />
                        <v-row justify="center" align="center">
                          <v-list-item-title>รหัสพนักงาน</v-list-item-title>
                        </v-row>
                        <v-row justify="center" align="center">
                          <v-col cols="12" sm="3">
                            <v-text-field
                              class="centered-input text--darken-3 mt-3"
                              color="#871B12"
                              single-line
                              v-model="formUpdate.empCode"
                              :error="false"
                              required
                              dense
                            ></v-text-field>
                          </v-col>
                        </v-row>

                        <v-btn
                          v-if="rollHR"
                          rounded
                          dark
                          color="#CA3433"
                          depressed
                          @click="dialogAdd = true"
                        >
                          <v-icon left>mdi-camera-outline</v-icon>
                          แก้ไข รูปโปรไฟล์
                        </v-btn>

                        <!-- ADD -->
                        <v-dialog
                          v-model="dialogAdd"
                          persistent
                          max-width="50%"
                        >
                          <v-card cols="12">
                            <v-card-title>
                              <span class="headline">อัพโหลดรูปโปรไฟล์</span>
                            </v-card-title>
                            <v-card-text>
                              <v-container>
                                <v-row>
                                  <v-file-input
                                    v-model="files"
                                    show-size
                                    counter
                                    prepend-icon="mdi-camera"
                                    :rules="imageRules"
                                    accept="image/png, image/jpeg"
                                    label="นำเข้า รูปภาพ"
                                  ></v-file-input>
                                </v-row>
                              </v-container>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                v-if="dataReady"
                                elevation="2"
                                x-large
                                color="dark darken-1"
                                text
                                @click="dialogAdd = false"
                              >
                                <v-icon left> mdi-cancel</v-icon>
                                ปิด
                              </v-btn>
                              <v-btn
                                elevation="2"
                                x-large
                                color="success"
                                text
                                @click="editData()"
                              >
                                <v-icon left>mdi-checkbox-marked-circle</v-icon>
                                เพิ่ม
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-container>
                    </v-col>
                  </v-list>
                  <v-list three-line subheader>
                    <!--{{formUpdate}}-->
                    <v-card-text>
                        <v-container class="py-1">
                          <v-form
                            ref="form_add"
                            v-model="valid_add"
                            lazy-validation
                          >
                            <v-row>
                              <div>
                                <v-card elevation="20">
                                  <v-card-title class="text-h5">
                                    <v-col cols="12">
                                      <v-text-field
                                        label="ข้อมูลส่วนตัว"
                                        disabled
                                      ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="4">
                                      <v-select
                                        :items="titleNameTH"
                                        v-model="formUpdate.empTitle_NameTH"
                                        label="คำนำหน้า *"
                                        :error="false"
                                        :readonly="!can"
                                        required
                                        dense
                                        outlined
                                        placeholder="Select..."
                                      ></v-select>
                                    </v-col>

                                    <v-col cols="12" sm="4">
                                      <v-text-field
                                        label="ชื่อ ภาษาไทย *"
                                        v-model="formUpdate.empFirst_NameTH"
                                        :rules="nameRules"
                                        :error="false"
                                        :readonly="!can"
                                        counter="30"
                                        maxlength="30"
                                        required
                                        dense
                                        outlined
                                      ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="4">
                                      <v-text-field
                                        v-model="formUpdate.empLast_NameTH"
                                        label="นามสกุล ภาษาไทย *"
                                        :rules="nameRules"
                                        :readonly="!can"
                                        :error="false"
                                        counter="30"
                                        maxlength="30"
                                        required
                                        dense
                                        outlined
                                      />
                                    </v-col>

                                    <v-col cols="12" sm="4">
                                      <v-select
                                        :items="titleNameEN"
                                        v-model="formUpdate.empTitle_NameEN"
                                        label="คำนำหน้า *"
                                        :error="false"
                                        :readonly="!can"
                                        required
                                        dense
                                        outlined
                                        placeholder="Select..."
                                      ></v-select>
                                    </v-col>

                                    <v-col cols="12" sm="4">
                                      <v-text-field
                                        v-model="formUpdate.empFirst_NameEN"
                                        label="ชื่อ ภาษาอังกฤษ *"
                                        :rules="nameRules"
                                        :error="false"
                                        :readonly="!can"
                                        counter="30"
                                        maxlength="30"
                                        required
                                        dense
                                        outlined
                                      />
                                    </v-col>

                                    <v-col cols="12" sm="4">
                                      <v-text-field
                                        v-model="formUpdate.empLast_NameEN"
                                        label="นามสกุล ภาษาอังกฤษ *"
                                        :rules="nameRules"
                                        :error="false"
                                        :readonly="!can"
                                        counter="30"
                                        maxlength="30"
                                        required
                                        dense
                                        outlined
                                      />
                                    </v-col>

                                    <v-col cols="12" sm="4">
                                      <v-text-field
                                        v-model="formUpdate.empNickname"
                                        label="ชื่อเล่น *"
                                        :rules="nameRules"
                                        :error="false"
                                        :readonly="!can"
                                        counter="10"
                                        maxlength="10"
                                        required
                                        dense
                                        outlined
                                      />
                                    </v-col>

                                    <v-col cols="12" sm="4">
                                      <v-select
                                        :items="get_gender"
                                        v-model="formUpdate.empGender"
                                        label="เพศ *"
                                        :error="false"
                                        :readonly="!can"
                                        required
                                        dense
                                        outlined
                                        placeholder="Select..."
                                      ></v-select>
                                    </v-col>

                                    <v-col cols="12" sm="4">
                                      <v-menu
                                        ref="menu5"
                                        v-model="menu5"
                                        :close-on-content-click="false"
                                        :return-value.sync="date"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                      >
                                        <template
                                          v-slot:activator="{ on, attrs }"
                                        >
                                          <v-text-field
                                            v-model="formUpdate.empBirthday"
                                            :value="computedDateBB"
                                            label="วัน-เดือน-ปี เกิด *"
                                            required
                                            :error="false"
                                            :rules="nameRules"
                                            dense
                                            outlined
                                            prepend-icon="mdi-calendar"
                                            :disabled="!rollHR"
                                            v-bind="attrs"
                                            v-on="on"
                                            :hint="showDateTH"
                                            persistent-hint
                                          ></v-text-field>
                                        </template>
                                        <v-date-picker
                                          v-model="formUpdate.empBirthday"
                                          :readonly="!rollHR"
                                          locale="th-th"
                                          no-title
                                          scrollable
                                        >
                                          <v-spacer></v-spacer>
                                          <v-btn
                                            text
                                            color="primary"
                                            @click="menu5 = false"
                                          >
                                            Cancel
                                          </v-btn>
                                          <v-btn
                                            text
                                            color="primary"
                                            @click="
                                              $refs.menu5.save(
                                                formUpdate.empBirthday
                                              )
                                            "
                                          >
                                            OK
                                          </v-btn>
                                        </v-date-picker>
                                      </v-menu>
                                    </v-col>

                                    <v-col cols="12" sm="4">
                                      <v-text-field
                                        v-model="formUpdate.AGE"
                                        label="อายุ"
                                         :disabled="true"
                                        :error="false"
                                        counter="3"
                                        readonly
                                        required
                                        dense
                                        outlined
                                      />
                                    </v-col>

                                    <v-col cols="12" sm="4">
                                      <v-select
                                        v-if="formUpdate.empGender == 'ชาย'"
                                        :items="Military_Status"
                                        v-model="
                                          formUpdate.masMilitaryStatusCode
                                        "
                                        label="สถานภาพทางทหาร"
                                        :error="false"
                                        :readonly="!can"
                                        placeholder="Select..."
                                        required
                                        dense
                                        outlined
                                      ></v-select>
                                    </v-col>

                                    <v-col cols="12" sm="4">
                                      <v-select
                                        :items="Marital_Status"
                                        v-model="
                                          formUpdate.masMaritalStatusCode
                                        "
                                        label="สถานภาพสมรส"
                                        :error="false"
                                        :readonly="!can"
                                        required
                                        dense
                                        outlined
                                        placeholder="Select..."
                                      ></v-select>
                                    </v-col>
                                  </v-card-title>
                                </v-card>
                                <br />
                                <br />
                              </div>
                              <div>
                                <v-card elevation="20">
                                  <v-card-title class="text-h5">
                                    <v-col cols="12">
                                      <template>
                                        <v-text-field
                                          label="ข้อมูลบัตรประจำตัวประชาชน "
                                          color="success"
                                          disabled
                                        ></v-text-field>
                                      </template>
                                    </v-col>

                                    <v-col cols="12" sm="4">
                                      <v-text-field
                                        v-model="formUpdate.empIDCard"
                                        label="เลขบัตรประจำตัวประชาชน *"
                                        maxlength="13"
                                        hint="(กรณีเลขบัตรไม่ถูกกรุณาติดต่อฝ่ายบุคคล)"
                                        :rules="IDcardRules"
                                        :error="false"
                                        counter="13"
                                        :readonly="!rollHR"
                                        required
                                        dense
                                        outlined
                                      />
                                    </v-col>

                                    <v-col cols="12" sm="4">
                                      <v-menu
                                        ref="menu4"
                                        v-model="menu4"
                                        :close-on-content-click="false"
                                        :return-value.sync="date"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                      >
                                        <template
                                          v-slot:activator="{ on, attrs }"
                                        >
                                          <v-text-field
                                            v-model="formUpdate.issuedDate"
                                            :value="computedDateDD"
                                            label="วันที่ออกบัตร *"
                                            required
                                            dense
                                            outlined
                                            :error="false"
                                            prepend-icon="mdi-calendar"
                                            :disabled="!rollHR"
                                            v-bind="attrs"
                                            v-on="on"
                                            :hint="showIssuedDate"
                                            persistent-hint
                                          ></v-text-field>
                                        </template>
                                        <v-date-picker
                                          :readonly="!rollHR"
                                          v-model="formUpdate.issuedDate"
                                          locale="th-th"
                                          no-title
                                          scrollable
                                        >
                                          <v-spacer></v-spacer>
                                          <v-btn
                                            text
                                            color="primary"
                                            @click="menu4 = false"
                                          >
                                            Cancel
                                          </v-btn>
                                          <v-btn
                                            text
                                            color="primary"
                                            @click="
                                              $refs.menu4.save(
                                                formUpdate.issuedDate
                                              )
                                            "
                                          >
                                            OK
                                          </v-btn>
                                        </v-date-picker>
                                      </v-menu>
                                    </v-col>

                                    <v-col cols="12" sm="4">
                                      <v-menu
                                        ref="menu3"
                                        v-model="menu3"
                                        :close-on-content-click="false"
                                        :return-value.sync="date"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                      >
                                        <template
                                          v-slot:activator="{ on, attrs }"
                                        >
                                          <v-text-field
                                            v-model="formUpdate.expireDate"
                                            :value="computedDateEE"
                                            label="วันหมดอายุ *"
                                            required
                                            dense
                                            outlined
                                            :error="false"
                                            :rules="nameRules"
                                            prepend-icon="mdi-calendar"
                                            :disabled="!rollHR"
                                            v-bind="attrs"
                                            v-on="on"
                                            :hint="showExpireDate"
                                            persistent-hint
                                          ></v-text-field>
                                        </template>
                                        <v-date-picker
                                          :readonly="!rollHR"
                                          v-model="formUpdate.expireDate"
                                          locale="th-th"
                                          no-title
                                          scrollable
                                        >
                                          <v-spacer></v-spacer>
                                          <v-btn
                                            text
                                            color="primary"
                                            @click="menu3 = false"
                                          >
                                            Cancel
                                          </v-btn>
                                          <v-btn
                                            text
                                            color="primary"
                                            @click="
                                              $refs.menu3.save(
                                                formUpdate.expireDate
                                              )
                                            "
                                          >
                                            OK
                                          </v-btn>
                                        </v-date-picker>
                                      </v-menu>
                                    </v-col>

                                    <v-col cols="12"  sm="6">
                                      <v-text-field
                                        v-model="formUpdate.issuedAt"
                                        label="ออกให้ ณ อำเภอ *"
                                        :rules="nameRules"
                                        :error="false"
                                        :readonly="!can"
                                        counter="30"
                                        maxlength="30"
                                        required
                                        dense
                                        outlined
                                      />
                                    </v-col>

                                    <v-col cols="12" sm="6">
                                      <v-text-field
                                        v-model="formUpdate.issuedProvince"
                                        label="จังหวัด ที่ออก *"
                                        :rules="nameRules"
                                        :error="false"
                                        :readonly="!can"
                                        counter="30"
                                        maxlength="30"
                                        required
                                        dense
                                        outlined
                                      />
                                    </v-col>
                                  </v-card-title>
                                </v-card>
                                <br />
                                <br />
                              </div>

                              <div>
                                <v-card elevation="20">
                                  <v-card-title class="text-h5">
                                    <v-col cols="12">
                                      <template>
                                        <v-text-field
                                          label="ข้อมูลการติดต่อ"
                                          color="success"
                                          disabled
                                        ></v-text-field>
                                      </template>
                                    </v-col>

                                    <v-col cols="12" sm="4">
                                      <v-text-field
                                        v-model="formUpdate.empTel"
                                        label="เบอร์โทรศัพท์ *"
                                        maxlength="10"
                                        counter="10"
                                        :rules="numberRules"
                                        :error="false"
                                        :readonly="!can"
                                        required
                                        dense
                                        outlined
                                      />
                                    </v-col>

                                    <v-col cols="12" sm="4">
                                      <v-text-field
                                        v-model="formUpdate.empEmergencyCall"
                                        label="เบอร์โทรสำรอง"
                                        maxlength="10"
                                        :readonly="!can"
                                        counter="10"
                                        required
                                        dense
                                        outlined
                                      />
                                    </v-col>

                                    <v-col cols="12" sm="4">
                                      <v-text-field
                                        v-model="formUpdate.empEmail"
                                        label="อีเมล์ *"
                                        :readonly="!can"
                                        counter="50"
                                        maxlength="50"
                                        value="example"
                                        required
                                        dense
                                        outlined
                                      />
                                    </v-col>

                                    <v-col cols="12" sm="4">
                                      <v-text-field
                                        v-model="formUpdate.empFacebook"
                                        label="Facebook"
                                        :readonly="!can"
                                        counter="30"
                                        maxlength="30"
                                        required
                                        dense
                                        outlined
                                      />
                                    </v-col>

                                    <v-col cols="12" sm="4">
                                      <v-text-field
                                        v-model="formUpdate.empLineID"
                                        label="LINE ID"
                                        :readonly="!can"
                                        counter="20"
                                        maxlength="20"
                                        required
                                        dense
                                        outlined
                                      />
                                    </v-col>
                                  </v-card-title>
                                </v-card>
                                <br />
                                <br />
                              </div>

                              <div>
                                <v-card elevation="20">
                                  <v-card-title>
                                    <v-col cols="12">
                                      <template>
                                        <v-text-field
                                          label="ข้อมูลใบอนุญาตการขับขี่"
                                          color="success"
                                          disabled
                                        ></v-text-field>
                                      </template>
                                    </v-col>

                                    <v-col cols="12" sm="6">
                                      <v-text-field
                                        v-model="formUpdate.empDriverLicense"
                                        :readonly="!can"
                                        label="เลขที่ ใบอนุญาตขับขี่รถยนต์"
                                        counter="8"
                                        maxlength="8"
                                        required
                                        dense
                                        outlined
                                      />
                                    </v-col>

                                    <v-col cols="12" sm="6">
                                      <v-text-field
                                        v-model="formUpdate.empDriverLicenseType"
                                        :readonly="!can"
                                        label="ประเภท ใบอนุญาตขับขี่รถยนต์"
                                        counter="20"
                                        maxlength="20"
                                        required
                                        dense
                                        outlined
                                      />
                                    </v-col>

                                    <v-col cols="12">
                                      <template>
                                        <v-text-field
                                          label="ความสามารถพิเศษ"
                                          color="success"
                                          disabled
                                        ></v-text-field>
                                      </template>
                                    </v-col>

                                    <v-col cols="12">
                                      <v-autocomplete
                                        clearable
                                        v-model="formUpdate.hobby"
                                        :items="MyHobby"
                                        :readonly="!can"
                                        label="งานอดิเรก"
                                        multiple
                                        hint="งานอดิเรก 3 อันดับ"
                                        persistent-hint
                                        dense
                                        outlined
                                        require
                                      ></v-autocomplete>
                                    </v-col>

                                    <v-col cols="12" sm="12">
                                       <v-textarea
                                       rows="3"
                                        row-height="25"
                                        v-model="formUpdate.empGenius"
                                        :readonly="!can"
                                        label="ความสามารถทางอาชีพ"
                                        counter="200"
                                        maxlength="200"
                                        dense
                                        outlined
                                        persistent-hint
                                      ></v-textarea>
                                    </v-col>
                                  </v-card-title>
                                </v-card>
                              </div>
                            </v-row>
                          </v-form>
                        </v-container>
                    </v-card-text>
                  </v-list>
                      <v-alert
                      v-if="!valid_add"
                      border="right"
                      colored-border
                      type="error"
                      elevation="20"
                    >
                      กรอกข้อมูลตามคำแนะนำของระบบให้ครบถ้วน
                    </v-alert>
                  <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

                  <!-- <v-col cols="12" class="text-right">
                    <v-btn
                      small
                      color="success"
                      :disabled="!valid_add"
                      @click="editData()"
                    >
                      บันทึกข้อมูล
                    </v-btn>
                  </v-col> -->
                </v-card>
                <br />
                <br />
                <br />
                <v-row no-gutters v-if="can">
                  <v-footer fixed height="60px" color="#262A34">
                    <v-col class="text-right">
                      <v-btn small color="success" @click="pushAddress" :disabled="!valid_add">
                        บันทึกข้อมูล
                        <v-icon right>mdi-checkbox-marked-circle</v-icon>
                      </v-btn>
                    </v-col>
                  </v-footer>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import EmpMenu from './EmployeeMenu.vue'
import moment from 'moment'
import titleNameTH from '../../../assets/master/titleName/titleNameTH.json'
import titleNameEN from '../../../assets/master/titleName/titleNameEN.json'
import genderNameTH from '../../../assets/master/Gender/genderNameTH.json'
import maritalStatusTH from '../../../assets/master/MaritalStatus/maritalStatusTH.json'
import hobbyTH from '../../../assets/master/Hobby/hobbyTH.json'
import militaryStatusTH from '../../../assets/master/MilitaryStatus/militaryStatusTH.json'

export default {
  components: {
    'left-emp-menu': EmpMenu,
    moment
  },
  created () {
    // setInterval(this.getNowGlobal, 1000)
  },
  computed: {
    computedDateBB () {
      if (this.formUpdate.empBirthday) {
        let dateTh = moment(this.formUpdate.empBirthday)
          .locale('th')
          .add(543, 'year')
          .format('LL')
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.showDateTH = dateTh
        return this.showDateTH
      }
    },
    computedDateDD () {
      if (this.formUpdate.issuedDate) {
        let dateTh1 = moment(this.formUpdate.issuedDate)
          .locale('th')
          .add(543, 'year')
          .format('LL')
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.showIssuedDate = dateTh1
        return this.showIssuedDate
      }
    },
    computedDateEE () {
      if (this.formUpdate.expireDate) {
        let dateTh2 = moment(this.formUpdate.expireDate)
          .locale('th')
          .add(543, 'year')
          .format('LL')
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.showExpireDate = dateTh2
        return this.showExpireDate
      }
    }
  },
  data () {
    return {
      rollHR: false,
      showDateTH: '',
      showIssuedDate: '',
      showExpireDate: '',
      value: 1,
      PK: '',
      path: '/employee/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: '* กรณีข้อมูลไม่ถูกต้องกรุณาแจ้งแก้ไข',
          disabled: true
        },
        {
          text: 'แก้ไขข้อมูล คลิกที่นี้',
          disabled: false,
          href: '/HRM/Employee/EmployeeInfoIssue'
        }
      ],
      // End Menu Config
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      menu5: false,
      menu4: false,
      menu3: false,
      valid_add: true,
      dialogAdd: false,
      formAdd: {
        empImageUrl: ''
      },
      formUpdate: {
        empCode: '',
        empFull_NameTH: '',
        empTitle_NameTH: '',
        empFirst_NameTH: '',
        empLast_NameTH: '',
        empTitle_NameEN: '',
        empFirst_NameEN: '',
        empLast_NameEN: '',
        empNickname: '',
        empBirthday: '',
        empGender: '',
        empIDCard: '',
        empEmail: '',
        empTel: '',
        empEmergencyCall: '',
        empFacebook: '',
        empLineID: '',
        empDriverLicense: '',
        empDriverLicenseType: '',
        masMaritalStatusCode: '',
        masMilitaryStatusCode: '',
        issuedDate: '',
        expireDate: '',
        issuedAt: '',
        issuedProvince: '',
        hobby: [],
        empImageUrl: '',
        empFileUpload: '',
        empCodeOld: '',
        empGenius: ''
      },
      dataImg: '',
      imageRules: [
        (value) =>
          !value ||
          value.size < 2000000 ||
          'Avatar size should be less than 2 MB!'
      ],
      nameRules: [(v) => !!v || 'Input is required'],
      emailRules: [
        (v) => !!v || 'E-mail is required',
        (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid'
      ],
      numberRules: [
        (v) =>
          (!isNaN(parseFloat(v)) && v >= 0 && v <= 9999999999) ||
          'กรุณา กรอกเป็นตัวเลข 0-9',
        (v) => (v && v.length === 10) || 'Max 10 characters'
      ],
      IDcardRules: [
        (v) =>
          (!isNaN(parseFloat(v)) && v >= 0 && v <= 9999999999999) ||
          'กรุณา กรอกเป็นตัวเลข 0-9',
        (v) =>
          (v && v.length === 13) || 'กรุณา กรอกเลขบัตรประจำตัวประชาชนให้ครบ 13 หลัก'
      ],
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      // End Export Config
      titleNameTH: titleNameTH,
      titleNameEN: titleNameEN,
      MyHobby: hobbyTH,
      get_gender: genderNameTH,
      Marital_Status: maritalStatusTH,
      Military_Status: militaryStatusTH,
      empId: '',
      files: null,
      dataEmp: [],
      can: false
    }
  },
  async mounted () {
    this.dataReady = false
    await this.getGetTokenForEmployee()
    await this.checkEmpData()
  },
  methods: {
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        default:
          break
      }
    },
    async checkEmpData () {
      this.can = localStorage.getItem('CanEdit')
      this.can = (this.can === 'true')

      if (localStorage.getItem('roll') === 'GA') {
        this.dataEmp = JSON.parse(localStorage.getItem('dataByHR'))
      } else if (localStorage.getItem('roll') === 'HR') {
        this.rollHR = true
        this.dataEmp = JSON.parse(localStorage.getItem('dataByHR'))
      } else {
        this.dataEmp = JSON.parse(localStorage.getItem('data'))
      }
      if (localStorage.getItem('roll')) {
        await this.SubmitDataById()
      }
    },
    async SubmitDataById () {
      console.log(this.dataEmp)
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + "getEmpCode?empCode=" + this.dataEmp.empCode,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          if (response.data) {
            Object.assign(this.formUpdate, response.data[0])
            this.formUpdate.hobby = JSON.parse(this.formUpdate.hobby)
            this.dataImg = this.DNS_IP + '/' + this.formUpdate.empImageUrl
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log(error)
        })
    },
    async editData () {
      let id = this.formUpdate['empId']
      let dt = this.formUpdate
      this.dataReady = false
      this.dialogAdd = false

      // console.log('file', this.files)
      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          if (this.files) {
            await this.fileupload()
          }

          let databylogin = localStorage.getItem('data')
          let ds = {
            empTitle_NameTH: dt.empTitle_NameTH,
            empFirst_NameTH: dt.empFirst_NameTH,
            empLast_NameTH: dt.empLast_NameTH,
            empTitle_NameEN: dt.empTitle_NameEN,
            empFirst_NameEN: dt.empFirst_NameEN,
            empLast_NameEN: dt.empLast_NameEN,
            empNickname: dt.empNickname,
            empBirthday: dt.empBirthday,
            empGender: dt.empGender,
            empIDCard: dt.empIDCard,
            empEmail: dt.empEmail,
            empTel: dt.empTel,
            empEmergencyCall: dt.empEmergencyCall,
            empFacebook: dt.empFacebook,
            empLineID: dt.empLineID,
            empDriverLicense: dt.empDriverLicense,
            empDriverLicenseType: dt.empDriverLicenseType,
            masMaritalStatusCode: dt.masMaritalStatusCode,
            masMilitaryStatusCode: dt.masMilitaryStatusCode,
            issuedDate: dt.issuedDate,
            expireDate: dt.expireDate,
            issuedAt: dt.issuedAt,
            issuedProvince: dt.issuedProvince,
            hobby: JSON.stringify(dt.hobby),
            empImageUrl: dt.empImageUrl,
            empFileUpload: dt.empFileUpload,
            empCodeOld: dt.empCodeOld,
            empGenius: dt.empGenius,
            LAST_USER: databylogin.userName
          }
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "editInfo/" + id,
              ds,
              {
                headers: {
                  'Application-Key': localStorage.getItem('ApplicationKey')
                }
              }
            )
            .then(async (response) => {
              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              this.dataReady = true
              console.log(response)
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log(error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error function editDataSubmit 3  : ', error)
        })
    },
    async pushAddress () {
      let id = this.formUpdate['empId']
      let dt = this.formUpdate
      let databylogin = localStorage.getItem('data')

      let ds = {
        empTitle_NameTH: dt.empTitle_NameTH,
        empFirst_NameTH: dt.empFirst_NameTH,
        empLast_NameTH: dt.empLast_NameTH,
        empTitle_NameEN: dt.empTitle_NameEN,
        empFirst_NameEN: dt.empFirst_NameEN,
        empLast_NameEN: dt.empLast_NameEN,
        empNickname: dt.empNickname,
        empBirthday: dt.empBirthday,
        empGender: dt.empGender,
        empIDCard: dt.empIDCard,
        empEmail: dt.empEmail,
        empTel: dt.empTel,
        empEmergencyCall: dt.empEmergencyCall,
        empFacebook: dt.empFacebook,
        empLineID: dt.empLineID,
        empDriverLicense: dt.empDriverLicense,
        empDriverLicenseType: dt.empDriverLicenseType,
        masMaritalStatusCode: dt.masMaritalStatusCode,
        masMilitaryStatusCode: dt.masMilitaryStatusCode,
        issuedDate: dt.issuedDate,
        expireDate: dt.expireDate,
        issuedAt: dt.issuedAt,
        issuedProvince: dt.issuedProvince,
        hobby: JSON.stringify(dt.hobby),
        empImageUrl: dt.empImageUrl,
        empFileUpload: dt.empFileUpload,
        empCodeOld: dt.empCodeOld,
        empGenius: dt.empGenius,
        LAST_USER: databylogin.userName
      }
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + "editInfo/" + id,
          ds,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          if (response.status === 200) {
            this.$swal('บันทึกข้อมูลเรียบร้อย', 'โปรด ตรวจสอบข้อมูลหน้าถัดไป', 'success')
            this.$router.push(
              '/HRM/Employee/EmployeeAddress'
            )
          }
          // this.$router.push(
          //   '/HRM/Employee/EmployeeAddress'
          // )
        })
      // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    selectImg () {
      if (this.files) {
        this.formUpdate.empImageUrl = URL.createObjectURL(this.files)
      } else {
        this.formUpdate.empImageUrl = ''
      }
    },
    // async fileupload () {
    //   const _this = this
    //   let params = new FormData()
    //   // this.dataEmp.empCode
    //   // _this.data = JSON.parse(localStorage.getItem('data'))
    //   params.append('file', _this.files)

    //   axios
    //     .post(this.DNS_IP + '/employee/upload', params, {
    //       headers: {
    //         'Code': _this.dataEmp.empCode
    //       }
    //     })
    //     .then(function (response) {
    //       console.log('file1', response.data)
    //       _this.formUpdate.empImageUrl = response.data
    //       _this.dataImg = _this.DNS_IP + '/' + response.data
    //     })
    // },
    async fileupload () {
      const _this = this
      let params = new FormData()
      // _this.data = JSON.parse(localStorage.getItem('data'))
      params.append('file', _this.files)
      params.append('profile', _this.profile)
      console.log('this.files', _this.files)
      console.log('this.files', _this.files.size)
      if (_this.files.size < 5000000) {
        try {
          await axios
            .post(_this.DNS_IP + '/employee/upload', params, {
              headers: {
                'Application-Key': _this.$session.getAll().ApplicationKey,
                Code: _this.dataEmp.empCode
              }
            })
            .then(function (response) {
              // console.log('file1', response.data)
              _this.formUpdate.empImageUrl = response.data
              _this.dataImg = _this.DNS_IP + '/' + response.data
            }).catch((error) => {
              alert(error)
              _this.formAdd.leaveFile = null
              return null
            })
        } catch (error) {
          alert(error)
          _this.files = null
        }
        console.log('this.files', _this.files)
        console.log('this.files', _this.files.size)
      } else {
        _this.files = null
      }
    }
  }
}
</script>
<style scope>
.scroll {
  overflow-y: scroll;
}
.lighten-5 {
  font-family: Kanit;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 20px;

  color: #871b12;
}
.centered-input input {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/Employee/EmployeeInfo.vue